var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMail = function SvgMail(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M856.2 842.1c-189.4.1-521.6 1.6-711.5 2.7C65.3 845.3.8 781.1.8 701.7V211.5l99.8 82.7L472 603.7c7.3 7.7 17.4 12.1 28 12.1s20.8-4.4 28.1-12.1l457.1-381 14-10.8V699c0 79-64 143-143 143.1m90.1-687L500 527 53.7 155.1z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMail);
export default ForwardRef;